export default "__VITE_ASSET__CVJ4xPkD__"